// extracted by mini-css-extract-plugin
export default {"actions":"ReportPromptPreview_actions__g3IA1"};